// extracted by mini-css-extract-plugin
export var container = "footer-module--container--05ec1";
export var content = "footer-module--content--d91e3";
export var links = "footer-module--links--8ad8a";
export var logoContainer = "footer-module--logoContainer--3d956";